import { Pipe, PipeTransform } from '@angular/core';
import { gfBoolFilter } from './data.functions';

@Pipe({
  name: 'gfBool'
})
export class BoolPipe implements PipeTransform {
    transform(inputValue?: any): boolean {
        return gfBoolFilter(inputValue);
    }
};